import { renderStaffInfoHeader } from '../../modules/actions/InfoStaffAppointment';
import { loadAllQuestions } from '../../modules/actions/allQuestionsActions';
import {
    customFields,
    isFlowForCalendar,
} from '../../utils/variables';

export function loadAllQuestionsPage() {
    const container = document.querySelector('.allQuestions__container');
    if (!container) return;

    container.classList.remove('hidden');

    handleLayoutClasses();

    renderStaffInfo();

    if (customFields && customFields.length > 0) {
        loadAllQuestions(customFields);
    }

    // Listeners are initialized inside loadAllQuestions()
}

function handleLayoutClasses() {
    const container = document.querySelector('.allQuestions__container');
    if (!container) return;

    if (isFlowForCalendar) {
        container.classList.remove('split-page');
    } else {
        container.classList.add('split-page');
    }
}

function renderStaffInfo() {
    const infoStaffContainer = document.querySelector('.allQuestions__container .infoStaff');
    if (!infoStaffContainer) return;

    if (!isFlowForCalendar || shouldShowStaffInfo()) {
        renderStaffInfoHeader(null, null, 'allQuestions__container');
    } else {
        infoStaffContainer.style.display = 'none';
    }
}

function shouldShowStaffInfo() {
    return !isFlowForCalendar || needsSplitPage();
}

function needsSplitPage() {
    return !isFlowForCalendar;
}

export function hideAllQuestionsPage() {
    const container = document.querySelector('.allQuestions__container');
    if (container) {
        container.classList.add('hidden');
    }
}
